import { createClient } from '@supabase/supabase-js'
// Supabase project details
const SUPABASE_URL = 'https://mqqcxbzfpiqyieokdxta.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1xcWN4YnpmcGlxeWllb2tkeHRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg3OTk2MzQsImV4cCI6MjA3NDM3NTYzNH0.gCij8F4Lf1F1oZAQ976P3vAy7aZ37LeEtTwy0eEAzzU'
// Create a single supabase client for interacting with your database
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
